var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.item
    ? _c(
        _setup.Button,
        {
          staticClass: "btn-sm me-1 p-1 d-flex align-items-center text-nowrap",
          attrs: {
            "active-value": _vm.index === _setup.activeEditorKey,
            "active-class": "btn-primary",
            "default-class": _setup.typeColourClass,
          },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _setup.selectTab.apply(null, arguments)
            },
          },
        },
        [
          _c("i", {
            staticClass: "me-1 bi-x",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _setup.removeEditor.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c("small", [_vm._v(_vm._s(_setup.item.title))]),
          _vm._v(" "),
          _c("span", {
            staticClass: "rounded ps-1 pt-1 ms-2 me-1",
            class: { "bg-warning": _vm.editor.isModified },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }